import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PageCacheService {
  cache = {};
  documentModified = false;
  constructor() {
    this.cache = {};
    this.documentModified = false;
  }

  contains(key) {
    //if (!key in this.cache) return false;
    if (key in this.cache) return false;
    var cached = this.cache[key];
    if (cached === undefined || cached.status !== 0 || cached.page === undefined) return false;
    return true;
  }

  setDocumentModified(value) {
    this.documentModified = this.documentModified || value;
  }

  add(key, page) {
    if (page === undefined || page.status !== 0 || page.page === undefined) {
      delete this.cache[key];
      return;
    }
    this.cache[key] = page;
  }

  get(key) {
    if (key in this.cache) {
      return this.deepCopy(this.cache[key]);
    }
    return undefined;
  }

  deepCopy(input) {
    var output;

    if (input === null || typeof input !== "object") {
      return input;
    }

    output = Array.isArray(input) ? [] : {};

    for (var key in input) {
      output[key] = this.deepCopy(input[key]);
    }

    return output;
  }

  getDocumentModified() {
    return this.documentModified;
  }

  pagesToCache(pages, currentPageNumber) {
    // We have 5 pages in cache
    var pageIndices = [currentPageNumber - 1, currentPageNumber, currentPageNumber - 2, currentPageNumber + 1, currentPageNumber - 3];
    var cachePages = [];
    for (var i in pageIndices) {
      var idx = pageIndices[i];
      if (idx >= 0 && idx < pages.length) {
        cachePages.push(pages[idx]);
      }
    }
    // Remove other pages from cache
    var deletePages = [];
    for (var p in this.cache) {
      if (cachePages.indexOf(p) < 0) {
        deletePages.push(p);
      }
    }
    for (var p in deletePages) {
      console.log("Removed page from cache " + deletePages[p]);
      delete this.cache[deletePages[p]];
    }

    return cachePages;
  }

  clear() {
    this.cache = {};
  }
}
